module.exports = __webpack_public_path__ + "static/media/home-skid-steer-loaders.babb0826.jpg";